import { createApi } from '@redux/createApi';
import { createSlice } from '@reduxjs/toolkit';
import { serialize } from '../../../shared/lib/serialize';
import { format } from '../../../shared/lib/format';

const tags = {
  getMarketingMetrics: 'getMarketingMetrics',
};

export const marketingApi = createApi({
  reducerPath: 'marketingApi',
  tagTypes: [tags.getMarketingMetrics],
  endpoints: (builder) => ({
    getMarketingMetrics: builder.query({
      query: (queryParams) => {
        const [start, end] = queryParams;

        let params = {};

        if (start) {
          params = {
            ...params,
            start: `${start.getDate()}/${format.addZeroBefore(start.getMonth() + 1)}/${start.getFullYear()}`,
          };
        }

        if (end) {
          params = {
            ...params,
            end: `${end.getDate()}/${format.addZeroBefore(end.getMonth() + 1)}/${end.getFullYear()}`,
          };
        }

        const queryString = serialize(params);
        return { url: `/admin/marketing/metrics?${queryString}`, method: 'GET' };
      },
      providesTags: [tags.getMarketingMetrics],
    }),
  }),
});

export const {
  useGetMarketingMetricsQuery,
} = marketingApi;

// Slice for managing filter parameters
const initialState = {
  start: (() => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  })(),
  end: new Date(),
};

export const marketingParamsSlice = createSlice({
  name: 'marketingParams',
  initialState,
  reducers: {
    setParams: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetParams: () => initialState,
  },
});

export const { setParams, resetParams } = marketingParamsSlice.actions;
export const marketingParamsReducer = marketingParamsSlice.reducer;
export const marketingParamsSelector = (state) => state.marketingParams;
